<template>
    <div>
        <el-dialog title="公司信息" :visible.sync="dialogVisible" width="50%" :modal-append-to-body="false" @open="open">
            <el-descriptions title="" :column="2" class="right-label-descriptions">
                <el-descriptions-item label="公司名称">{{ companyData.name }}</el-descriptions-item>
                <el-descriptions-item label="统一社会信用代码">{{ companyData.creditIdentifier }}</el-descriptions-item>
                <el-descriptions-item label="注册地址">{{ companyData.mailingAddress }}</el-descriptions-item>
                <el-descriptions-item label="紧急联系电话">{{ companyData.emergencyNumber }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="" :column="1" class="right-label-descriptions">
                <el-descriptions-item label="经营范围名称">{{ companyData.businessScope }}</el-descriptions-item>
                <el-descriptions-item label="通讯地址">{{ companyData.mailingAddress }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="" :column="2" class="right-label-descriptions">
                <el-descriptions-item label="经营业户经济类型">{{ companyData.operationType }}</el-descriptions-item>
                <el-descriptions-item label="注册资本">{{ companyData.registeredCapital }}</el-descriptions-item>
                <el-descriptions-item label="法人代表姓名">{{ companyData.legalRepresentative }}</el-descriptions-item>
                <el-descriptions-item label="法人代表电话">{{ companyData.contactNumber }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ companyData.status === 1 ? '有效' : '无效' }}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{ companyData.contactPerson }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
// import { getEnterpriseInfo } from '../service'
export default {
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            companyData: {}
        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        closeClick() {
            this.dialogVisible = false
        },
        open() {
            console.log(JSON.stringify(this.companyData));
        }
    },
};
</script>
<style scoped lang="less">
::v-deep .el-descriptions .el-descriptions-item__cell {
    padding-bottom: 25px;
}

::v-deep .el-descriptions-item__label {
    width: 140px !important;
    text-align: right !important;
    justify-content: flex-end !important;
    padding-right: 16px !important;
}

::v-deep .el-descriptions__label {
    width: 140px !important;
    text-align: right !important;
}

::v-deep .el-descriptions__table td.el-descriptions-item__label {
    width: 140px !important;
    text-align: right !important;
}

/* 对单列描述项设置更宽的标签宽度 */
::v-deep .el-descriptions[class*="right-label-descriptions"][column="1"] .el-descriptions-item__label {
    width: 160px !important;
}
</style>